<script setup>
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

const props = defineProps({
    invoiceProforma: Object,
    agent: Object,
});
dayjs.extend(advancedFormat);

function getAdultChildInfant(clients) {
    let adult = 0;
    let child = 0;
    let infant = 0;
    clients.forEach((client) => {
        if (client.dob == null) {
            adult++;
        } else if (dayjs().diff(client.dob, 'year') < 2) {
            infant++;
        } else {
            child++;
        }
    });
    return adult + ' / ' + child + ' / ' + infant;
}

//currency formatter
function formatPrice(value) {
    let val = (value / 1).toFixed(2).replace('.', '.');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getTotalInvoiceAmount() {
    let total = 0;
    props.invoiceProforma.invoicedetails.forEach((invoiceDetail) => {
        total += parseFloat(invoiceDetail.amount);
    });
    return total;
}

//get total invoice amount in words
function getTotalInvoiceAmountInWords() {
    let total = getTotalInvoiceAmount();
    let totalInWords = convertNumberToWords(total);
    return totalInWords;
}

//convert number to words
function convertNumberToWords(amount) {
    let words = new Array();
    words[0] = '';
    words[1] = 'One';
    words[2] = 'Two';
    words[3] = 'Three';
    words[4] = 'Four';
    words[5] = 'Five';
    words[6] = 'Six';
    words[7] = 'Seven';
    words[8] = 'Eight';
    words[9] = 'Nine';
    words[10] = 'Ten';
    words[11] = 'Eleven';
    words[12] = 'Twelve';
    words[13] = 'Thirteen';
    words[14] = 'Fourteen';
    words[15] = 'Fifteen';
    words[16] = 'Sixteen';
    words[17] = 'Seventeen';
    words[18] = 'Eighteen';
    words[19] = 'Nineteen';
    words[20] = 'Twenty';
    words[30] = 'Thirty';
    words[40] = 'Forty';
    words[50] = 'Fifty';
    words[60] = 'Sixty';
    words[70] = 'Seventy';
    words[80] = 'Eighty';
    words[90] = 'Ninety';
    amount = amount.toString();
    let atemp = amount.split(".");
    let number = atemp[0].split(",").join("");
    let n_length = number.length;
    let words_string = "";
    if (n_length <= 9) {
        let n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let received_n_array = new Array();
        for (let i = 0; i < n_length; i++) {
            received_n_array[i] = number.substr(i, 1);
        }
        for (let i = 9 - n_length, j = 0; i < 9; i++, j++) {
            n_array[i] = received_n_array[j];
        }
        for (let i = 0, j = 1; i < 9; i++, j++) {
            if (i == 0 || i == 2 || i == 4 || i ==
                7) {
                if (n_array[i] == 1) {
                    n_array[j] = 10 + parseInt(n_array[j]);
                    n_array[i] = 0;
                }
            }
        }
        let value = "";
        for (let i = 0; i < 9; i++) {
            if (i == 0 || i == 2 || i == 4 || i ==
                7) {
                value = n_array[i] * 10;
            } else {
                value = n_array[i];
            }
            if (value != 0) {
                words_string += words[value] + " ";
            }
            if ((i == 1 && value != 0) || (i == 0 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Crores ";
            }
            if ((i == 3 && value != 0) || (i == 2 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Lakhs ";
            }
            if ((i == 5 && value != 0) || (i == 4 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Thousand ";
            }
            if (i == 6 && value != 0 && (n_array[i +
                1] != 0 && n_array[i + 2] != 0)) {
                words_string += "Hundred and ";
            } else if (i == 6 && value != 0) {
                words_string += "Hundred ";
            }
        }
        words_string = words_string.split("  ").join(" ");
    }
    return words_string;
}
</script>
<template>
    <div class="row invoice-preview">
        <!-- Invoice -->
        <div class="col-xl-9 col-md-8 col-12 mb-md-0 mb-4">
            <div class="card invoice-preview-card">
                <div class="card-body pb-0 pt-0">
                    <div
                        class="d-flex justify-content-between flex-xl-row flex-md-column flex-sm-row flex-column p-sm-3 p-0">
                        <div class="mb-xl-0 mb-4">
                            <div class="d-flex svg-illustration mb-3 gap-2">
                                <span class="app-brand-logo demo">
                                    <img style="width:140px;" v-if="props.agent.company"
                                        :src="'/storage/company_logos/' + props.agent.company?.logo" alt="logo">
                                    <img style="width:140px;" v-else
                                        :src="'/storage/company_logos/' + props.agent?.logo" alt="logo">
                                </span>
                            </div>
                            <span v-if="props.invoiceProforma?.currency == 'USD'">
                                <span v-if="props.agent.company" v-html="props.agent.company?.address1"></span>
                                <span v-else v-html="props.agent?.address1"></span>
                            </span>
                            <span v-if="props.invoiceProforma?.currency == 'INR'">
                                <span v-if="props.agent.company" v-html="props.agent.company?.address2"></span>
                                <span v-else v-html="props.agent?.address2"></span>
                            </span>
                        </div>
                        <div>
                            <h4>Invoice #{{ props.invoiceProforma.invoice_no }}</h4>
                            <div class="mb-2">
                                <span class="me-1">Date Created:</span>
                                <span class="fw-semibold">
                                    {{ dayjs(props.invoiceProforma.created_at).format('Do MMM YYYY') }}
                                </span>
                            </div>
                            <div>
                                <span class="me-1 text-danger">Date Due:</span>
                                <span class="fw-semibold">
                                    {{ dayjs(props.invoiceProforma.payment_due).format('Do MMM YYYY') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="my-0" />
                <div class="card-body pt-0 pb-0">
                    <div class="row p-sm-3 p-0">
                        <div class="col-xl-6 col-md-12 col-sm-5 col-12 mb-xl-0 mb-md-4 mb-sm-0 mb-4">
                            <h6 class="pb-2">Invoice To:</h6>
                            <p class="mb-1">{{ props.invoiceProforma.bookings.agent.agency_name }}</p>
                            <p class="mb-1">{{ props.invoiceProforma.bookings.agent.agency_address }}</p>
                            <p class="mb-1">{{ props.invoiceProforma.bookings.agent.agency_TIN }}</p>
                            <p class="mb-1">{{ props.invoiceProforma.bookings.agent.agency_email }}</p>
                        </div>
                        <div class="col-xl-6 col-md-12 col-sm-7 col-12"
                            style="font-size: 13px;letter-spacing: .5px; background-color: #e1f5fe; border-radius:4px; padding-top:6px;">
                            <div class="row" style="line-height:25px;">
                                <tbody>
                                    <div>
                                        <td class="pe-3"><strong>Booking Number:</strong></td>
                                        <td><strong>{{ props.invoiceProforma.bookings?.booking_no }}</strong>
                                        </td>
                                    </div>
                                    <div>
                                        <span class="pe-3"><strong>Confirmation Ref:</strong></span>
                                        <span style="width:10px;">{{
                                            props.invoiceProforma.bookings?.resort_confirmation_number
                                            }}
                                        </span>
                                    </div>
                                    <tr>
                                        <td class="pe-3"><strong>Property Name:</strong></td>
                                        <td>{{ props.invoiceProforma.bookings.hotel?.name }}</td>
                                    </tr>
                                    <tr>
                                        <td v-if="props.invoiceProforma.bookings?.stay_type == 1" class="pe-3">
                                            <strong>Rooom Type (Split Stay):</strong>
                                        </td>
                                        <td v-else class="pe-3"><strong>Rooom Type:</strong></td>
                                        <td>
                                            <span v-for="roomtype in props.invoiceProforma.bookings.booking_rooms"
                                                :key="roomtype.id">
                                                <span>{{ roomtype.room_category?.name }} <b>For</b> {{
                                                    roomtype.nights
                                                    }}
                                                    Nights </span>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Meal Plan:</strong></td>
                                        <td>{{ props.invoiceProforma.bookings.meal_type }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Arrival:</strong></td>
                                        <td>{{ dayjs(props.invoiceProforma.bookings?.arrival_date).format('ddd,\
                                            Do MMM YYYY')
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Departure:</strong></td>
                                        <td>{{
                                            dayjs(props.invoiceProforma.bookings?.departure_date).format('ddd,\
                                            Do MMM YYYY')
                                        }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>ADT/CHD/INF:</strong></td>
                                        <td>{{ getAdultChildInfant(props.invoiceProforma.bookings?.client) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Arr / Dep Transfer:</strong></td>
                                        <td>{{ props.invoiceProforma.bookings?.transfers[0]?.vessel }} / {{
                                            props.invoiceProforma.bookings?.transfers[1]?.vessel
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Guest Name:</strong></td>
                                        <td>{{ props.invoiceProforma.bookings?.client[0]?.title
                                            }}.{{ props.invoiceProforma.bookings?.client[0]?.first_name }}
                                            {{ props.invoiceProforma.bookings?.client[0]?.last_name }}
                                        </td>
                                    </tr>
                                    <tr v-if="props.invoiceProforma.remarks">
                                        <td class="pe-3"><strong>Remarks:</strong></td>
                                        <td>{{ props.invoiceProforma?.remarks }}</td>
                                    </tr>
                                </tbody>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive pb-0">
                    <table class="table border-top m-0">
                        <thead class="table-active">
                            <tr>
                                <th>Qty</th>
                                <th>Description</th>
                                <th>Rate</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="details in props.invoiceProforma.invoicedetails" :key="details.id">
                                <td class="col-md-2">{{ details.qty }}</td>
                                <td class="col-md-5">{{ details.description }}</td>
                                <td class="col-md-2">{{ formatPrice(details.rate) }}</td>
                                <td class="col-md-3">{{ formatPrice(details.amount) }}</td>
                            </tr>
                            <tr valign=top>
                                <td v-if="props.invoiceProforma.currency == 'USD'" colspan="2"
                                    class="align-top px-4 py-3" style="line-height:5px; font-size: 13px;">
                                    <p class="mb-3 col-md-6">
                                        <span class="me-1 fw-semibold">Account Details</span>
                                    </p>
                                    <span v-if="props.agent.company"
                                        v-html="props.agent.company?.account_details1"></span>
                                    <span v-else v-html="props.agent?.account_details1"></span>
                                </td>
                                <td v-if="props.invoiceProforma.currency == 'INR'" colspan="2"
                                    class="align-top px-4 py-3" style="line-height:5px; font-size: 13px;">
                                    <p class="mb-3 col-md-6">
                                        <span class="me-1 fw-semibold">Account Details</span>
                                    </p>
                                    <span v-if="props.agent.company"
                                        v-html="props.agent.company?.account_details2"></span>
                                    <span v-else v-html="props.agent?.account_details2"></span>
                                </td>
                                <td v-if="props.invoiceProforma.currency == 'AED'" colspan="2"
                                    class="align-top px-4 py-3" style="line-height:5px; font-size: 13px;">
                                    <p class="mb-3 col-md-6">
                                        <span class="me-1 fw-semibold">Account Details</span>
                                    </p>
                                    <span v-if="props.agent.company"
                                        v-html="props.agent.company?.account_details3"></span>
                                    <span v-else v-html="props.agent?.account_details3"></span>
                                </td>
                                <td class="text-end px-4 py-3">
                                    <p class="mb-2 fw-semibold">Total: </p>
                                </td>
                                <td class="px-4 py-3" style="font-size: 14px;">
                                    <p class="fw-semibold mb-2">{{ props.invoiceProforma.currency }} {{
                                        formatPrice(getTotalInvoiceAmount())
                                        }}</p>
                                    <p style="font-size: 13px;">({{
                                        getTotalInvoiceAmountInWords()
                                        }})</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12" v-if="props.invoiceProforma.currency == 'INR'">
                            <span class="fw-semibold">Note:</span>
                            <span v-if="props.agent.company" v-html="props.agent.company?.footer_text"></span>
                            <span v-else v-html="props.agent?.footer_text"></span>
                        </div>
                        <span style="text-align: center;">This is a computer-generated document and does not require a
                            signature.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>